import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'src/contexts/AppContext';
import { useSiteTimezoneContext } from 'src/contexts/SiteTimezoneContext/SiteTimezoneContext';
import { AggregateMetricsTimePeriod, SaleClient } from 'src/WebApiController';

export type RevenueChartData = {
  dateTime: string;
  totalRevenue: number;
};

export type MarketplaceChartData = Record<string, any>;

export function useGetAggregatedSaleMetrics(
  timePeriod: AggregateMetricsTimePeriod
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { timezoneOffsetMins } = useSiteTimezoneContext();
  const shouldQuery = !!activeAccountWebClientConfig?.activeAccountId;

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['getAggregatedSaleMetrics', timePeriod, timezoneOffsetMins],
    async queryFn() {
      const result = await new SaleClient(
        activeAccountWebClientConfig
      ).getAggregatedSaleMetrics(timePeriod, timezoneOffsetMins);
      return result.sort(
        (a, b) =>
          new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime()
      );
    },
    enabled: shouldQuery,
    staleTime: 1000 * 60 * 30, // 30 minutes
    refetchOnWindowFocus: false,
  });

  return {
    data,
    isLoading,
    isFetching,
  };
}
